import React from "react";

export default function KpiCard({ label, value, sub, trend, accent, testid }) {
  const trendColor = trend === "up" ? "text-emerald-600" : trend === "down" ? "text-red-600" : "text-slate-500";
  return (
    <div className="kpi-card bg-white border border-border rounded-md p-5 shadow-sm" data-testid={testid}>
      <div className="flex items-center justify-between">
        <div className="text-[10.5px] uppercase tracking-[0.08em] text-slate-500 font-semibold">{label}</div>
        {accent && <span className="w-2 h-2 rounded-full" style={{ background: accent }} />}
      </div>
      <div className="mt-3 font-mono-fin text-[26px] font-semibold text-slate-900">{value}</div>
      {sub && <div className={`mt-1.5 text-xs ${trendColor}`}>{sub}</div>}
    </div>
  );
}
